<template>
  <div>
    <!-- 动态列表的导出 -->
    <!-- 导出 -->
    <myDialog
      :diaWidth="diaWidth_dc"
      :dialogTitle="dialogTitle_dc"
      :isShowDialog="isShowDialog_dc"
      @handleCloseDia="handleCloseDia_dc"
      @diaCancelBtn="handleCloseDia_dc"
      @diaConfirmBtn="diaConfirmBtn_dc()"
    >
      <div class="glo_dialogForm">
        <h3>导出设置:</h3>
        <el-form
          class="diaForm"
          v-if="isShowDialog_dc"
          ref="dialogFormRef_dc"
          :model="dialogForm_dc"
          label-width="100px"
        >
          <el-form-item
            required
            class="dialogFormItems"
            prop="fileName"
            label="文件名:"
          >
            <el-input
              clearable
              placeholder="请输入(必填)"
              v-model="dialogForm_dc.fileName"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="pageStart" label="页码:">
            <el-input
              clearable
              placeholder="请输入(选填)"
              v-model="dialogForm_dc.pageStart"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="pageTotal"
            label="每页条数:"
          >
            <el-input
              clearable
              placeholder="请输入(选填),最多20000条"
              v-model="dialogForm_dc.pageTotal"
            ></el-input>
          </el-form-item>
          <el-form-item
            style="width: auto; padding: 0 10px"
            class="dialogFormItems"
            prop="pageTotal"
            label="导出等待类型:"
          >
            <el-radio-group v-model="dialogForm_dc.EpType">
              <el-radio label="dd">等待导出完成</el-radio>
              <el-radio label="bdd"
                >不等待,生成导出记录(到页面右上角查询结果)</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-form>

        <!--页面的查询条件 -->
        <h3 v-if="queryCondditionDatas.length > 0">查询条件:</h3>
        <div>
          <queryCondition
            ref="queryForm"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
          ></queryCondition>
        </div>
        <!-- <slot></slot> -->

        <!-- 表头 -->
        <!-- 可拖拽区域 -->
        <div>
          <div class="titles_dialog_1">
            <el-checkbox
              class="rowChecks_1"
              label="全选 (导出的Excel表头,可拖动排序)"
              v-model="EPAllCheck"
              @change="checkAll"
            >
            </el-checkbox>
          </div>
          <draggable v-model="epTableHeard2" @end="onAfterEnter">
            <transition-group>
              <div
                class="daraStyle_1"
                v-for="(element, index) in epTableHeard2"
                :key="element.field"
              >
                <el-checkbox
                  class="rowChecks_1"
                  label=""
                  v-model="element.isShow"
                  @change="checktab(index, $event)"
                >
                  {{ element.name }}
                </el-checkbox>
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
    </myDialog>
  </div>
</template>
  <script>
import myDialog from "@/components/Dialog.vue";
import queryCondition from "@/components/queryCondition.vue";
import draggable from "vuedraggable"; //拖拽组件
export default {
  props: {
    dialogTitle_dc: {
      typeof: String,
      default: "导出",
    },
    diaWidth_dc: {
      typeof: String,
      default: "50%",
    },
    isShowDialog_dc: {
      typeof: Boolean,
      default: false,
    },
    AllCheck: {
      typeof: Boolean,
      default: false,
    },
    tableHeard: {
      typeof: Array,
      default: [],
    },
    queryCondditionDatas: {
      typeof: Array,
      default: [],
    },
    dialogForm_dc: {
      typeof: Object,
      default: function () {
        return {
          pageStart: 1,
          pageTotal: null,
          fileName: null,
          apiName: null,
          EpType: "bdd",
          apiType: "POST",
          isJson: 0,
        };
      },
    },
  },
  components: {
    myDialog,
    queryCondition,
    draggable,
  },
  data() {
    return {
      isHaseMore: true,
      // queryCondditionDatas: [], //查询列表动态数据
      // newallCheck: false,
      // selectLength: 0,
      epTableHeard2: [], //
      EPAllCheck: false,
    };
  },
  watch: {
    queryCondditionDatas(a, b) {
    },
    AllCheck(a, b) {
      this.EPAllCheck = a;
    },
    tableHeard: {
      handler(a, b) {
        this.epTableHeard2 = a;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    // async initTable() {
    //   // 获取查询条件 list
    //   await this.$API
    //     .getReportConditions({
    //       number: this.reportFiledsNumber,
    //     })
    //     .then((res) => {
    //       let datas = res.data.result || [];
    //       if (datas && datas.length > 0) {
    //         console.log(datas);
    //         datas.map((n) => (n.conditonVal = n.conditonVal || ""));
    //         let arrs = datas.filter((n) => {
    //           return n.textBoxType === "datetime";
    //         });
    //         let timeobjs = {};
    //         arrs.forEach((item) => {
    //           let { sort, conditonKeyShow } = item;
    //           let name = conditonKeyShow.includes("起始")
    //             ? conditonKeyShow.split("起始").join("")
    //             : conditonKeyShow.split("结束").join("");
    //           if (!timeobjs[sort]) {
    //             timeobjs[sort] = {
    //               sort,
    //               name,
    //               children: [],
    //             };
    //           }
    //           timeobjs[sort].children.push(item);
    //         });
    //         let gdates = [];
    //         let dates = Object.values(timeobjs);
    //         if (dates.length) {
    //           gdates = [
    //             {
    //               textBoxType: "datetime",
    //               startTime_a: this.$TOOLS.getFlexDate(this.$COMMON.timeNum),
    //               endTime_a: this.$TOOLS.getCurrentDate(),
    //               timeType: "0",
    //               timeTypes: dates.map((n, i) => {
    //                 return { value: String(i), label: n.name };
    //               }),
    //               timeChilds: dates.map((n, i) => {
    //                 return { sort: n.sort, name: n.name, children: n.children };
    //               }),
    //             },
    //           ];
    //         }
    //         arrsConddition = [
    //           ...gdates,
    //           ...datas.filter((n) => {
    //             return n.textBoxType !== "datetime";
    //           }),
    //         ];
    //       }
    //     });
    //   // 获取 每个查询条件 的下拉数据
    //   arrsConddition.forEach(async (element, index) => {
    //     let { textBoxType } = element;
    //     if (textBoxType == "select") {
    //       element.selectOptions = [];
    //     }
    //   });
    //   this.queryCondditionDatas = arrsConddition;
    // },

    // 拖拽后 更新表头数组
    onAfterEnter(e) {
      this.$emit("onAfterEnter", this.epTableHeard2);
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia_dc() {
      this.$emit("handleCloseDia_dc", false);
    },
    //  弹窗确认保存事件
    diaConfirmBtn_dc() {
      this.$emit("diaConfirmBtn_dc");
    },

    checktab(idx, e) {
      this.$emit("checktabEP", idx, e, this.epTableHeard2);
    },
    checkAll(e) {
      this.$emit("checkAllEP", e, this.epTableHeard2);
    },
  },
};
</script>
  <style scoped lang='less'>
// 拖拽
.daraStyle_1 {
  height: 40px;
  line-height: 40px;
  border: 1px solid #d7d7d7;
  padding: 0 10px;
  border-bottom: none;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.daraStyle_1:hover {
  background-color: #f2f2f2;
}

.daraStyle_1:last-of-type {
  border-bottom: 1px solid #d7d7d7;
}
.rowChecks_1 {
  min-width: 120px;
  flex: 1;
}

.sort_templateNames {
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
  position: relative;
}
.sort_templateNames .originBtn {
  position: absolute;
  right: 0;
  // top: -10px;
  padding: 10px;
}
.titles_dialog_1 {
  font-size: 13px;
  color: #666;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px;
}
</style>